import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

export const Hero = ({ onCTAClick }) => {
  return (
    <section className="relative min-h-screen flex items-center bg-white">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=1920&q=85"
          alt="Imóvel em Portimão"
          className="w-full h-full object-cover"
        />
        {/* Mobile overlay (stronger for readability) + desktop gradient */}
        <div className="absolute inset-0 bg-white/85 md:bg-gradient-to-r md:from-white md:via-white/90 md:to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 lg:px-12 py-24 md:py-32">
        <div className="max-w-2xl">
          {/* Small label */}
          <div className="mb-6 md:mb-8" data-testid="hero-label">
            <span className="text-[10px] md:text-xs tracking-[0.2em] uppercase text-stone-500 font-medium">
              Rustem · Consultor Imobiliário · Portimão
            </span>
          </div>

          {/* Main Heading */}
          <h1 className="text-4xl sm:text-5xl md:text-7xl font-light text-stone-900 mb-8 leading-[1.05] tracking-tight" data-testid="hero-title">
            <span className="block uppercase tracking-[0.15em] text-2xl sm:text-3xl md:text-4xl font-extralight text-stone-700">Vamos</span>
            <span className="block italic font-serif text-stone-900 uppercase tracking-tight">Transformar Sonhos</span>
            <span className="block uppercase tracking-[0.15em] text-2xl sm:text-3xl md:text-4xl font-extralight text-stone-700 mt-1 md:mt-2">em</span>
            <span className="italic font-serif text-stone-900 uppercase tracking-tight">Moradas.</span>
          </h1>

          {/* Subheading */}
          <p className="text-base md:text-lg text-stone-700 md:text-stone-600 mb-10 md:mb-12 max-w-lg leading-relaxed font-light" data-testid="hero-subtitle">
            Compra e venda de imóveis em <span className="italic font-serif text-stone-900 uppercase tracking-tight">Portimão</span> e no <span className="italic font-serif text-stone-900 uppercase tracking-tight">Algarve</span> com o meu acompanhamento personalizado.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
            <Button
              size="lg"
              onClick={onCTAClick}
              data-testid="hero-cta-primary"
              className="bg-stone-900 hover:bg-stone-800 text-white px-8 py-6 text-sm font-medium tracking-wide rounded-none group transition-all min-h-[52px]"
            >
              Pedir contacto
              <ArrowRight className="ml-3 w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              size="lg"
              variant="ghost"
              onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}
              data-testid="hero-cta-secondary"
              className="bg-white text-stone-900 hover:bg-stone-100 px-8 py-6 text-sm font-medium tracking-wide rounded-none border border-stone-300 min-h-[52px]"
            >
              Conhecer os serviços
            </Button>
          </div>

          {/* Trust Stats — visible with proper contrast */}
          <div className="mt-12 md:mt-20 grid grid-cols-3 gap-6 sm:gap-8 max-w-md border-t border-stone-300 pt-6 md:pt-8" data-testid="hero-stats">
            <div>
              <div className="text-2xl md:text-3xl font-light text-stone-900">10</div>
              <div className="text-[10px] md:text-xs text-stone-600 mt-1 tracking-wide uppercase">Anos</div>
            </div>
            <div>
              <div className="text-2xl md:text-3xl font-light text-stone-900">1000+</div>
              <div className="text-[10px] md:text-xs text-stone-600 mt-1 tracking-wide uppercase">Imóveis</div>
            </div>
            <div>
              <div className="text-2xl md:text-3xl font-light text-stone-900">#1</div>
              <div className="text-[10px] md:text-xs text-stone-600 mt-1 tracking-wide uppercase">Portugal</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
